// Copyright (c) 2016 Deere & Company

import actions from '../../../action-list';
import {routerActions} from 'react-router-redux';

export const copyClaim = claim =>

    dispatch => {

        dispatch({
            isCopied: true,
            type: actions.COPY_CLAIM_MAINTENANCE_PLAN
        });

        dispatch(routerActions.replace(`/claims/maintenance-plan/new/${claim.pin}`));

    };



// WEBPACK FOOTER //
// ./src/claim/marketing/maintenance-plan/action-creators/copy-claim.js